export default __webpack_public_path__ + "static/media/cash.2210542e.svg";